<template>
  <section :id=id :style="{ opacity }">
    <component :is="screenItem.itemType" :event="screenItem" :opacity="opacity" :selected="selected"/>
  </section>
</template>

<script>
import BezierEasing from 'bezier-easing'

import Event from './Event'
import Intro from './Intro'
import Landing from './Landing'
import End from './End'

const easing = BezierEasing(1, 0.03, 0.67, 0.77)
const getCenter = (el) => (el.getBoundingClientRect().top + el.getBoundingClientRect().bottom) / 2

export default {
  name: 'screen',
  props: ['id', 'screenItem'],
  components: {
    Event,
    Intro,
    Landing,
    End
  },
  data () {
    return {
      center: null,
      opacity: 1,
      distanceToContainerCenter: 0,
      distance: 0,
      selected: false
    }
  },
  computed: {
    pagePosition () {
      return this.$store.state.pagePosition
    }
  },
  watch: {
    pagePosition () {
      this.center = getCenter(this.$el)
      this.distanceToContainerCenter = Math.abs(this.center - getCenter(this.$parent.$el))
      this.distance = this.distanceToContainerCenter / this.$el.clientHeight
      this.opacity = easing(Math.max(0, (1 - this.distance)))
      this.selected = this.opacity > 0.1
    },
    selected (newValue) {
      if (newValue) {
        window.history.pushState({}, null, '#' + this.id)
        this.$store.commit('setEventId', this.id)
      }
    }
  },
  methods: {
    next () {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss">
</style>
